<div class="bg-base-300 md:py-5 mx-10 md:mx-80 flex justify-center pt-5">
  <button
    class="flex btn bg-transparent hover:bg-transparent w-100 h-fit border-0 w-48 shadow-none dark:hidden"
  >
    <img class="w-full" src="/assets/logo/qwiko360-hz-logo-dark.svg" alt="" />
  </button>
  <button
    class="btn bg-transparent hover:bg-transparent w-100 h-fit border-0 w-48 shadow-none hidden dark:!flex"
  >
    <img class="w-full" src="/assets/logo/qwiko360-hz-logo-light.svg" alt="" />
  </button>
</div>
